import { MarginType } from '@katanaperps/katana-perps-sdk';
import React from 'react';
import styled from 'styled-components';

const Chip = styled.span<{ $marginType: MarginType; $marginLeft?: string }>`
  display: inline-block;
  vertical-align: bottom;
  padding: 0 4px;
  border-radius: 2px;
  background: ${({ $marginType }) =>
    $marginType === 'isolated' ? 'var(--purple6)' : 'var(--blue8)'};
  color: var(--white);
  font-family: var(--standardFontFamily);
  font-size: var(--smallest);
  font-weight: 400;
  line-height: 16px;
  text-transform: capitalize;
  white-space: nowrap;
  ${({ $marginLeft }) => ($marginLeft ? `margin-left: ${$marginLeft};` : '')}
`;

interface Props {
  marginType: MarginType;
  marginLeft?: string;
}

/** Cross (blue) / Isolated (purple) margin type label */
export default function MarginTypeChip({ marginType, marginLeft }: Props) {
  return (
    <Chip $marginType={marginType} $marginLeft={marginLeft}>
      {marginType}
    </Chip>
  );
}
